/* TRAWOC — table of contents: highlight only.
   The list and the heading ids are rendered server-side by
   snippets/trawoc-toc.liquid, so the contents work with JavaScript off.
   This only marks which section the reader is currently in. */
(function () {
  function init() {
    var box = document.querySelector('[data-tw-toc]');
    if (!box || !('IntersectionObserver' in window)) return;

    var anchors = [].slice.call(box.querySelectorAll('a[href^="#"]'));
    if (!anchors.length) return;

    var links = {}, heads = [];
    anchors.forEach(function (a) {
      var id = a.getAttribute('href').slice(1);
      var el = id && document.getElementById(id);
      if (el) { links[id] = a; heads.push(el); }
    });
    if (!heads.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var a = links[en.target.id];
        if (a && en.isIntersecting) {
          anchors.forEach(function (x) { x.classList.remove('is-current'); });
          a.classList.add('is-current');
        }
      });
    }, { rootMargin: '-10% 0px -75% 0px' });
    heads.forEach(function (h) { io.observe(h); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
